import { render } from "./MmcRegistrationForm.vue?vue&type=template&id=2a18c8b4&scoped=true"
import script from "./MmcRegistrationForm.vue?vue&type=script&lang=js"
export * from "./MmcRegistrationForm.vue?vue&type=script&lang=js"

import "./MmcRegistrationForm.vue?vue&type=style&index=0&id=2a18c8b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a18c8b4"]])

export default __exports__